<label for="feature_{{feature.id}}">
  {{ feature.header }}@if (feature.unitHeader) {
  <span>, {{ feature.unitHeader }}</span>
}
@if (isRequired()) {
  <span> *</span>
}
@if (feature.comment) {
  <span nbTooltip="{{feature.comment}}">
    <tui-icon icon="lightbulb"/>
  </span>
}
</label>

<div class="accordion-item__right">
  <form [formGroup]="form" style="width: 100%;">
    <input nbInput
      type="text"
      fullWidth fieldSize="medium"
      [placeholder]="valueExample !== null ? valueExample : featureValuePlaceholder"
      formControlName="featureValue"
      />
    @if (featureValue.invalid && featureValue.errors && (featureValue.dirty || featureValue.touched)) {
      <div>
        @if (featureValue.hasError('pattern')) {
          <div class="text-danger" i18n="@@FeatureValueIncorrectError">
        Не корректное значение
      </div>
        }
        @if (featureValue.hasError('lowerGtUpperBoundary')) {
          <div class="text-danger" i18n="@@FeatureValueLowerGtUpperBoundaryError">
        Нижняя граница больше верхней
      </div>
        }
        @if (featureValue.hasError('notInteger')) {
          <div class="text-danger" i18n="@@FeatureValueNotIntegerError">
        Нижняя и верхняя границы должны быть целыми числами
      </div>
        }
        @if (featureValue.hasError('lowerMin')) {
          <div class="text-danger" i18n="@@FeatureValueLowerMinError">
        Минимальное значение нижней границы {{ featureValue.errors.lowerMin.min }}
      </div>
        }
        @if (featureValue.hasError('lowerMax')) {
          <div class="text-danger" i18n="@@FeatureValueLowerMaxError">
        Превышено максимальное значение нижней границы: {{ featureValue.errors.lowerMax.max }}
      </div>
        }
        @if (featureValue.hasError('upperMin')) {
          <div class="text-danger" i18n="@@FeatureValueUpperMinError">
        Минимальное значение верхней границы {{ featureValue.errors.upperMin.min }}
      </div>
        }
        @if (featureValue.hasError('upperMax')) {
          <div class="text-danger" i18n="@@FeatureValueUpperMaxError">
        Превышено максимальное значение верхней границы: {{ featureValue.errors.upperMax.max }}
      </div>
        }
      </div>
    }
  </form>
  <div class="accordion-item__right-info">
    @if (feature.fromMasterCard) {
      <div class="state-master-card" i18n-nbTooltip="@@FeatureFromMasterCard" nbTooltip="Характеристика заполнена из мастер карты">
        <tui-icon icon="credit-card"/>
      </div>
    }
    @if (featureValue.valid && isShowEmptyWarning()) {
      <div class="state-warn">
        <tui-icon icon="triangle-alert"/>
      </div>
    }
    @if (featureValue.invalid) {
      <div class="state-err">
        <tui-icon icon="circle-alert"/>
      </div>
    }
    @if (featureValue.valid && !isEmpty()) {
      <div class="state-success">
        <tui-icon icon="check"/>
      </div>
    }
    @if (featureLink) {
      <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
        class="entityID"
        target="_blank"
        i18n-nbTooltip="@@OpenFeatureInNewWindow"
        nbTooltip="Открыть характеристику в новом окне"
        >
        #{{ feature.featureId }}
      </a>
    }
    @if (showRemoveButton) {
      <button nbButton ghost size="tiny" status="danger" (click)="removeEvent.emit()" nbTooltip="Удалить характеристику МК" i18n-nbTooltip="@@DeleteMasterCardFeature">
        <tui-icon icon="trash-2"/>
      </button>
    }
  </div>
</div>
